<template>
    <ItemIndex :singular-name="singularName"
               :plural-name="pluralName"
               :item-type="indexType"
    >
        <template>
            <ItemIndexFilterNotification :show="filter.show" :type="filter.type" :term="filter.term"/>
            <v-data-table :search="searchTerm" :headers="headers" :items="items" :items-per-page="10" :loading="tableLoading">
                <template v-slot:item.question="{ item }">
                    <v-btn x-small :to="'/faq/edit/' + item.id" color="primary">
                        {{ item.question }}
                        <v-icon right x-small>fas fa-edit</v-icon>
                    </v-btn>
                </template>
                <template v-slot:item.published="{ item }">
                    <v-icon small color="primary" v-if="item.published === 1">fas fa-check-circle</v-icon>
                    <v-icon small color="error" v-else>fas fa-minus-circle</v-icon>
                </template>
            </v-data-table>
        </template>
    </ItemIndex>
</template>

<script>
import ItemIndexBoilerplate from '@/views/Admin/Config/Commonn/ItemIndexBoilerplate';
export default {
    mixins: [ ItemIndexBoilerplate ],

    data() {
        return {
            indexType: 'faq',
            singularName: 'FAQ',
            pluralName: 'FAQ\'s',
            responseObject: 'faqs',
            headers: [
                {
                    text: 'Question',
                    value: 'question',
                },
                {
                    text: 'Answer',
                    value: 'answer',
                },
                {
                    text: 'Order',
                    value: 'order',
                },
            ],
        };
    },
};
</script>
